module.exports = __webpack_public_path__ + "media/components/assets/img/icons/marker-to-4743a1e7333d7bf49724f5f42d6f42af.svg";